import React from 'react'
import styled from 'styled-components'
import HeroBg1 from '../../images/statistics-hero-img-left.png'
import HeroBg2 from '../../images/statistics-hero-img-right.png'
import { LAPTOP, DESKTOP, TABLET } from '../../utilities/breakpoints'

const StatisticsPageHero = ({ children }) => {
  return (
    <HeroContainer className="statistics-page-hero">
      <Bg1 src={HeroBg1} className="hero-bg" alt="icon"/>
      <Bg2 src={HeroBg2} className="hero-bg" alt="icon"/>
      <div className="hero-content">
        {children}
      </div>
    </HeroContainer>
  )
}

export default StatisticsPageHero;

const HeroContainer = styled.div`
  position: relative;
  background-color: #23233F;
  padding-bottom: 2rem;
  margin-bottom: 2rem;
  
  .hero-content {
    position: relative;
    z-index: 1;
    
    .finish-page__intro {
      color: #fff;
    }
  }
  
  @media${LAPTOP} {
    padding-bottom: 3rem;
    margin-bottom: 3rem;
  }
`

const Bg1 = styled.img`
  display: none;
  
  @media${DESKTOP} {
    display: block;
    position: absolute;
    width: 11%;
    max-width: 200px;
    height: auto;
    left: 0;
    top: 220px;
  }
`

const Bg2 = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  width: 40%;
  height: auto;
  max-width: 450px;
  z-index: 0;
  display: none;
  
  @media${TABLET} {
    display: block;
  }
`


// WEBPACK FOOTER //
// ./src/components/ui/statistics-page-hero.js